import FORM_AUDIENCE_TYPE from './FormAudienceType';

const PARENT_AUDIENCE_TYPE = {
    none: 0,
    withAccount: 1,
    withoutAccount: 2,
    applicant: 3,
    enquiry: 4,
};

const PARENT_AUDIENCE_OPTION = {
    withAccount: 'with-account',
    withoutAccount: 'without-account',
    applicantStatus: 'applicant-status',
};

const mapParentAudienceTypeToOption = (value) => {
    switch (Number(value)) {
        case PARENT_AUDIENCE_TYPE.withAccount:
            return PARENT_AUDIENCE_OPTION.withAccount;
        case PARENT_AUDIENCE_TYPE.withoutAccount:
            return PARENT_AUDIENCE_OPTION.withoutAccount;
        case PARENT_AUDIENCE_TYPE.applicant:
            return PARENT_AUDIENCE_OPTION.applicantStatus;
        default:
            return null;
    }
};

const mapParentAudienceOptionToType = (option) => {
    switch (option) {
        case 'with':
        case PARENT_AUDIENCE_OPTION.withAccount:
            return PARENT_AUDIENCE_TYPE.withAccount;
        case PARENT_AUDIENCE_OPTION.withoutAccount:
            return PARENT_AUDIENCE_TYPE.withoutAccount;
        case 'without':
        case PARENT_AUDIENCE_OPTION.applicantStatus:
            return PARENT_AUDIENCE_TYPE.applicant;
        default:
            return PARENT_AUDIENCE_TYPE.none;
    }
};

const getParentAudienceTypeForSelection = (audience, option = null) => {
    const numericAudience = Number(audience);

    if (numericAudience === FORM_AUDIENCE_TYPE.enquiries) {
        return PARENT_AUDIENCE_TYPE.enquiry;
    }

    if (numericAudience !== FORM_AUDIENCE_TYPE.parentsForChildCompletion) {
        return PARENT_AUDIENCE_TYPE.none;
    }

    return mapParentAudienceOptionToType(option);
};

const resolveFrontendAudience = (audience, parentAudienceType) => (
    Number(audience) === FORM_AUDIENCE_TYPE.parentsForChildCompletion &&
    Number(parentAudienceType) === PARENT_AUDIENCE_TYPE.enquiry
        ? FORM_AUDIENCE_TYPE.enquiries
        : Number(audience)
);

const resolveBackendAudiencePayload = (audience, parentAudienceType) => {
    const numericAudience = Number(audience);

    if (numericAudience === FORM_AUDIENCE_TYPE.enquiries) {
        return {
            audience: FORM_AUDIENCE_TYPE.parentsForChildCompletion,
            parentAudienceType: PARENT_AUDIENCE_TYPE.enquiry,
        };
    }

    if (numericAudience === FORM_AUDIENCE_TYPE.parentsForChildCompletion) {
        return {
            audience: FORM_AUDIENCE_TYPE.parentsForChildCompletion,
            parentAudienceType: Number(parentAudienceType) || PARENT_AUDIENCE_TYPE.none,
        };
    }

    return {
        audience: numericAudience,
        parentAudienceType: PARENT_AUDIENCE_TYPE.none,
    };
};

export {
    PARENT_AUDIENCE_TYPE,
    PARENT_AUDIENCE_OPTION,
    getParentAudienceTypeForSelection,
    mapParentAudienceOptionToType,
    mapParentAudienceTypeToOption,
    resolveBackendAudiencePayload,
    resolveFrontendAudience,
};
